import '../App.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Projects({getRandomColor}) {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/data/portfolio.json')
      .then((res) => res.json())
      .then((data) => setProjects(data.projects))
      .catch((err) => console.error('Failed to load projects:', err));
  }, []);

  return (
    <div className="projects-container">
      <h1>Projects</h1>
      {projects.map((project, idx) => (
        <div key={idx} className='project-card'>
          <div className='lines'>
            <div className='project-line'><span className='braces' style={{ fontFamily: "'Courier New', Courier, monospace"}}>{'{'}</span></div>
            <div className='project-line'><span className="key title">"title"</span><span className="title">: </span><Link to={`/projects/${project.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}><b className="value title-value" style={{color: getRandomColor()}}>"{project.title}"</b></Link><span className="title">,</span></div>
            <div className='project-line'><span className="key">"description"</span>: <span className="value wrap">"{project.description}",</span></div>
            <div className='project-line'><span className="key">"tags"</span>: [<span className="value">{project.tags.map((tag, i) => (
              <span key={i}>"{tag}"{i < project.tags.length - 1 ? ', ' : ''}</span>
            ))}</span>],</div>
            {project.link && (
              <div className='project-line'>
                <span className="key">"link"</span>: <a href={project.link} target="_blank" rel="noopener noreferrer" className="link wrap">"{project.link}"</a>,
              </div>
            )}            
            <div className='project-line'><span className="key">"documentation"</span>: <Link to={`/projects/${project.slug}`}><button className="braces-button">View Documentation</button></Link></div>
            <div className='project-line'><span className='braces' style={{ fontFamily: "'Courier New', Courier, monospace", fontSize: 'large' }}>{idx !== projects.length - 1 ? '},' : '}'}</span></div>
          </div>
          <div className='project-img-wrapper'>
            <img src={process.env.PUBLIC_URL + project.img} alt=""/>
          </div>
        </div>
      ))}
    </div>
  );
}